import React, { useMemo, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import classnames from 'classnames'

import { UikSelect, UikFormInputGroup } from 'components'
// TODO: Create a reusable MultiSelect component. Instead of using profile one
import ProfileMultiSelect from 'components/Profile/ProfileMultiSelect'
import { constants } from 'helpers'
import { SET_TAG } from '../constants'
import cls from '../EventForm.module.scss'
import CardHeader from '../components/CardHeader'
import FieldTitle from '../components/FieldTitle'

const {
  EVENT_CONSTANTS: {
    SEXUAL_ORIENTATIONS: { STRAIGHT, GAY, LESBIAN },
  },
} = constants

const FormatStep = ({
  formState,
  setFormState,
  handleChange,
  formats,
  ageGroups,
  sexualOrientation,
  isAdmin,
}) => {
  const eventFormats = useMemo(
    () =>
      formats.map(({ name, longName }) => ({
        value: name,
        label: longName,
      })),
    [formats]
  )
  const [eventFormatOption, setEventFormatOption] = useState(eventFormats.slice(0, 1))
  const sexualOrientationOptions = useMemo(
    () =>
      sexualOrientation.map(({ id, name }) => ({
        value: id,
        label: name,
      })),
    [sexualOrientation]
  )
  const [sexualOrientationOption, setSexualOrientationOption] = useState(
    sexualOrientationOptions.slice(0, 1)
  )
  useEffect(() => {
    if (!isEmpty(eventFormatOption)) {
      setFormState({
        eventFormat: eventFormatOption[0].value,
      })
    }
    if (!isEmpty(ageGroups)) {
      setFormState({
        type: SET_TAG,
        tag: { age_group: [ageGroups[0].id] },
      })
    }
    if (!isEmpty(sexualOrientationOption)) {
      setFormState(getSexualOrientationData(sexualOrientationOption[0].value))
    }
  }, [eventFormatOption, ageGroups, sexualOrientationOption, setFormState])

  return (
    <div className={cls.cardContainer}>
      <CardHeader stepNumber="2" title="Choose your event type" showInfoCircle={false} />
      <div className={cls.card}>
        <div className={cls.fieldContainer}>
          {eventFormatOption && (
            <>
              <FieldTitle title="Round Length" />
              <div className={cls.selectWrappper}>
                <UikFormInputGroup horizontal>
                  <UikSelect
                    placeholder={eventFormatOption.label}
                    className={cls.selectItem}
                    options={eventFormats}
                    position="bottomRight"
                    name="eventFormat"
                    value={eventFormatOption}
                    defaultValue={eventFormatOption}
                    onChange={value => setEventFormatOption([value])}
                  />
                </UikFormInputGroup>
              </div>
            </>
          )}
        </div>
        <div className={cls.fieldContainer}>
          <div className={cls.fieldTitle}>Sexual Orientation</div>
          <div className={cls.selectWrappper}>
            <UikFormInputGroup horizontal>
              <UikSelect
                placeholder={formState.sexualOrientation}
                className={cls.selectItem}
                options={sexualOrientationOptions}
                position="bottomRight"
                name="sexualOrientation"
                value={sexualOrientationOption}
                defaultValue={sexualOrientationOption}
                onChange={selected => {
                  setSexualOrientationOption([selected])
                  setFormState(getSexualOrientationData(selected.value))
                }}
              />
            </UikFormInputGroup>
          </div>
        </div>
        {isAdmin && (
          <div className={cls.fieldContainer}>
            <div className={cls.fieldTitle}>Sexual Orientation (Admin Only)</div>
            <div className={cls.selectWrappper}>
              <UikFormInputGroup horizontal>
                <ProfileMultiSelect
                  isMulti
                  options={sexualOrientationOptions}
                  name="sexualOrientationV1"
                  onChange={({ values }) =>
                    setFormState({ sexualOrientationV1: values.map(({ value }) => value) })
                  }
                />
              </UikFormInputGroup>
            </div>
          </div>
        )}
        <div className={cls.fieldContainer}>
          <FieldTitle title="Age" />
          <div className="flex justify-between">
            <input
              className={classnames('text-center w-2/5', cls.textInput)}
              placeholder="Min Age"
              name="minAge"
              min="18"
              type="number"
              onChange={handleChange}
              value={formState.minAge}
            />
            <input
              className={classnames('w-2/5 text-center', cls.textInput)}
              placeholder="Max Age"
              name="maxAge"
              min="18"
              type="number"
              onChange={handleChange}
              value={formState.maxAge}
            />
          </div>
        </div>
        <div className={cls.fieldContainer}>
          <FieldTitle title="Scheduled" />
          <input
            type="checkbox"
            className={classnames(cls.textInput)}
            name="scheduled"
            checked={formState.scheduled}
            onChange={e => setFormState({ [e.target.name]: e.target.checked })}
          />
        </div>
      </div>
    </div>
  )
}

FormatStep.propTypes = {
  formats: PropTypes.array.isRequired,
  ageGroups: PropTypes.array.isRequired,
  sexualOrientation: PropTypes.array.isRequired,
}

const minTickets = orientation => {
  switch (orientation) {
    case STRAIGHT:
      return {
        MALE: 5,
        FEMALE: 5,
      }
    case GAY:
      return {
        MALE: 6,
        FEMALE: 0,
      }
    case LESBIAN:
      return {
        MALE: 0,
        FEMALE: 6,
      }
    default:
      return 6
  }
}

const getSexualOrientationData = value => ({
  type: SET_TAG,
  ticketQuantity: minTickets(value),
  tag: { sexual_orientation: [value] },
  maxTickets: value === STRAIGHT ? 10 : 0,
})

export default FormatStep
